<template>
  <div class="richtext">
    <Vue3RuntimeTemplate :template="resolvedRichText"></Vue3RuntimeTemplate>
  </div>
</template>

<script setup lang="ts">
import Vue3RuntimeTemplate from "vue3-runtime-template"

const props = defineProps({
  document: {
    type: Object,
    required: true,
  },
})

const resolvedRichText = computed(() => {
  return renderRichText(props.document, {
    resolver: (component, blok) => {
      return `<component :blok='${JSON.stringify(blok)}' is="${component}" />`
    },
  })
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>

<style lang="scss">
@import "@/styles/shared.scss";
.richtext {
  ol,
  ul,
  p,
  hr,
  > .media {
    margin-block: $p3;

    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  p {
    color: rgba($cl-light, 0.75);
  }

  b,
  strong {
    font-weight: 700;
    color: inherit;
  }

  ul,
  ol {
    li {
      margin-top: $p1;

      &:first-child {
        margin-top: 0;
      }
    }
  }
  ol {
    padding-left: 2rem;

    li {
      padding-left: 1rem;
      list-style-type: number;
    }
  }
  ul {
    padding-left: 1.5rem;

    li {
      position: relative;
      padding-left: 1.5rem;
      list-style-type: disc;
    }
  }
  blockquote {
    @include type-body1;
    font-style: italic;
  }
  code {
    font-family: $font-display;
    white-space: pre;
  }
  hr {
    display: block;
    width: 100%;
    height: 2px;
    background: currentColor;
  }
}
</style>
